"use client";
import React, { createContext, useContext, useReducer } from "react";

const enum DialogActionKind {
  SHOWSIGNIN = "show_sign_in",
  SHOWSIGNUP = "show_sign_up",
  SHOWRECOVERPASS = "show_recover_pass",
  SHOWSIGNUPCODE = "show_sign_up_code",
  SHOWRECOVERPASSCODE = "show_recover_pass_code",
  CLOSEDIALOG = "close_dialog",
}

interface State {
  isDialogOpen: boolean;
  isSignIn: boolean;
  isSignUp: boolean;
  isSignUpCode: boolean;
  isRecoverPass: boolean;
  isRecoverPassCode: boolean;
}

interface DialogContextType {
  showSignIn(): void;
  showSignUp(): void;
  showSignUpCode(): void;
  showRecoverPass(): void;
  showRecoverPassCode(): void;
  closeDialog(): void;
  state: State;
}

const initialState: State = {
  isDialogOpen: false,
  isSignIn: false,
  isSignUp: false,
  isSignUpCode: false,
  isRecoverPass: false,
  isRecoverPassCode: false,
};

function reducer(state: State, action: DialogActionKind) {
  switch (action) {
    case DialogActionKind.SHOWSIGNIN: {
      return {
        isDialogOpen: true,
        isSignIn: true,
        isSignUp: false,
        isSignUpCode: false,
        isRecoverPass: false,
        isRecoverPassCode: false,
      };
    }
    case DialogActionKind.SHOWSIGNUP: {
      return {
        isDialogOpen: true,
        isSignIn: false,
        isSignUp: true,
        isSignUpCode: false,
        isRecoverPass: false,
        isRecoverPassCode: false,
      };
    }
    case DialogActionKind.SHOWSIGNUPCODE: {
      return {
        isDialogOpen: true,
        isSignIn: false,
        isSignUp: false,
        isSignUpCode: true,
        isRecoverPass: false,
        isRecoverPassCode: false,
      };
    }
    case DialogActionKind.SHOWRECOVERPASS: {
      return {
        isDialogOpen: true,
        isSignIn: false,
        isSignUp: false,
        isSignUpCode: false,
        isRecoverPass: true,
        isRecoverPassCode: false,
      };
    }
    case DialogActionKind.SHOWRECOVERPASSCODE: {
      return {
        isDialogOpen: true,
        isSignIn: false,
        isSignUp: false,
        isSignUpCode: false,
        isRecoverPass: false,
        isRecoverPassCode: true,
      };
    }
    case DialogActionKind.CLOSEDIALOG: {
      return {
        isDialogOpen: false,
        isSignIn: false,
        isSignUp: false,
        isSignUpCode: false,
        isRecoverPass: false,
        isRecoverPassCode: false,
      };
    }
  }
}

const AuthContext = createContext<DialogContextType>(undefined as any);

export function AuthContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  function showSignIn(): void {
    dispatch(DialogActionKind.SHOWSIGNIN);
  }
  function showSignUp(): void {
    dispatch(DialogActionKind.SHOWSIGNUP);
  }
  function showSignUpCode(): void {
    dispatch(DialogActionKind.SHOWSIGNUPCODE);
  }
  function showRecoverPass(): void {
    dispatch(DialogActionKind.SHOWRECOVERPASS);
  }
  function showRecoverPassCode(): void {
    dispatch(DialogActionKind.SHOWRECOVERPASSCODE);
  }

  function closeDialog(): void {
    dispatch(DialogActionKind.CLOSEDIALOG);
  }

  return (
    <AuthContext.Provider
      value={{
        state,
        showSignIn,
        showSignUp,
        showSignUpCode,
        showRecoverPass,
        showRecoverPassCode,
        closeDialog,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthDialogsContext() {
  return useContext(AuthContext);
}
